var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "green-border-box in-padd white-bg row",
      staticStyle: { "min-height": "400px" }
    },
    [
      _c(
        "div",
        {
          staticClass: "sort-control",
          staticStyle: { "margin-bottom": "20px" }
        },
        [
          _vm._v("\n    Filter By\n    "),
          _c(
            "div",
            { staticStyle: { display: "inline-flex", "margin-left": "10px" } },
            [
              _c("date-range-picker", {
                staticStyle: { width: "100%", margin: "auto" },
                attrs: {
                  opens: "center",
                  "date-format": _vm.dateFormat,
                  "locale-data": { format: "dd-mm-yyyy" },
                  autoApply: true
                },
                on: { update: _vm.updateList },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function(picker) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(picker.startDate.toDateString()) +
                            " - " +
                            _vm._s(picker.endDate.toDateString()) +
                            "\n       "
                        )
                      ]
                    }
                  }
                ]),
                model: {
                  value: _vm.dateRange,
                  callback: function($$v) {
                    _vm.dateRange = $$v
                  },
                  expression: "dateRange"
                }
              })
            ],
            1
          ),
          _c("br"),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.storeId,
                  expression: "storeId"
                }
              ],
              staticStyle: { "margin-top": "10px", "margin-left": "0px" },
              on: {
                change: [
                  function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.storeId = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                  _vm.updateList
                ]
              }
            },
            [
              _c("option", { attrs: { value: "", selected: "" } }, [
                _vm._v("  Select Physical Location ")
              ]),
              _vm._l(_vm.stores, function(store) {
                return _c(
                  "option",
                  { key: store.id, domProps: { value: store.id } },
                  [_vm._v(_vm._s(store.name))]
                )
              })
            ],
            2
          ),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.state,
                  expression: "state"
                }
              ],
              staticStyle: { "margin-bottom": "15px" },
              on: {
                change: [
                  function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.state = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                  _vm.updateList
                ]
              }
            },
            [
              _c("option", { attrs: { value: "", selected: "" } }, [
                _vm._v(" State")
              ]),
              _vm._l(_vm.states, function(state) {
                return _c("option", { key: state.name }, [
                  _vm._v(_vm._s(state.name))
                ])
              })
            ],
            2
          ),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.taskId,
                  expression: "taskId"
                }
              ],
              staticStyle: { "margin-left": "15px" },
              on: {
                change: [
                  function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.taskId = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                  _vm.updateList
                ]
              }
            },
            [
              _c("option", { attrs: { value: "", selected: "" } }, [
                _vm._v("  Image Type")
              ]),
              _vm._l(_vm.tasks, function(task) {
                return _c(
                  "option",
                  { key: task.id, domProps: { value: task.id } },
                  [_vm._v(_vm._s(task.name))]
                )
              })
            ],
            2
          ),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.productId,
                  expression: "productId"
                }
              ],
              on: {
                change: [
                  function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.productId = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                  _vm.updateList
                ]
              }
            },
            [
              _c("option", { attrs: { value: "", selected: "" } }, [
                _vm._v(" Activities & Products ")
              ]),
              _vm._l(_vm.products, function(product) {
                return _c(
                  "option",
                  { key: product.id, domProps: { value: product.id } },
                  [_vm._v(_vm._s(product.name))]
                )
              })
            ],
            2
          ),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.socialSelfie,
                  expression: "socialSelfie"
                }
              ],
              on: {
                change: [
                  function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.socialSelfie = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                  _vm.updateList
                ]
              }
            },
            [
              _c("option", { attrs: { value: "0", selected: "" } }, [
                _vm._v(" Social Selfies")
              ]),
              _c("option", { attrs: { value: "1" } }, [_vm._v("Yes")])
            ]
          ),
          _c("br"),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.limit,
                  expression: "limit"
                }
              ],
              staticStyle: { float: "right" },
              on: {
                change: [
                  function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.limit = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                  _vm.updateList
                ]
              }
            },
            [
              _c("option", { attrs: { value: "8" } }, [_vm._v("8 per page")]),
              _c("option", { attrs: { value: "25" } }, [_vm._v("25 per page")]),
              _c("option", { attrs: { value: "50" } }, [_vm._v("50 per page")]),
              _c("option", { attrs: { value: "75" } }, [_vm._v("75 per page")]),
              _c("option", { attrs: { value: "100" } }, [
                _vm._v("100 per page")
              ])
            ]
          ),
          _c("h6", { staticClass: "totalCount" }, [
            _vm._v("Total Images: " + _vm._s(_vm.totalCount))
          ]),
          _c(
            "button",
            {
              staticClass: "btn btn-positive",
              staticStyle: { float: "right" },
              on: { click: _vm.toggleSelectable }
            },
            [_vm._v(_vm._s(_vm.toggleSelectableButtonName))]
          ),
          _vm.showsDownloadSelectedImagesButton
            ? _c(
                "button",
                {
                  staticClass: "btn btn-positive",
                  staticStyle: { float: "right" },
                  on: { click: _vm.downloadSelectedImages }
                },
                [_vm._v("Download Selected Images")]
              )
            : _vm._e(),
          _c("br"),
          _c("br")
        ]
      ),
      _vm.images.length > 0
        ? _c(
            "div",
            { staticClass: "row" },
            [
              _c(
                "viewer",
                { attrs: { images: _vm.images, options: _vm.viewerOptions } },
                _vm._l(_vm.images, function(image, index) {
                  return _c("div", { key: index }, [
                    _c(
                      "div",
                      {
                        staticClass: "col-xs-6 col-md-3",
                        class: _vm.selectablePicklDiv ? "selectable" : "",
                        staticStyle: { "margin-bottom": "20px" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "photo green-border-box",
                            staticStyle: {
                              border: "1px solid black !important"
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "img-contain",
                                staticStyle: {
                                  position: "relative",
                                  overflow: "hidden"
                                }
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.selectedPicklsList[index],
                                      expression: "selectedPicklsList[index]"
                                    },
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.selectablePicklDiv,
                                      expression: "selectablePicklDiv"
                                    }
                                  ],
                                  staticClass: "selecteble-check",
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    value: index,
                                    checked: Array.isArray(
                                      _vm.selectedPicklsList[index]
                                    )
                                      ? _vm._i(
                                          _vm.selectedPicklsList[index],
                                          index
                                        ) > -1
                                      : _vm.selectedPicklsList[index]
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = _vm.selectedPicklsList[index],
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = index,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.selectedPicklsList,
                                              index,
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.selectedPicklsList,
                                              index,
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(
                                          _vm.selectedPicklsList,
                                          index,
                                          $$c
                                        )
                                      }
                                    }
                                  }
                                }),
                                _c("img", {
                                  staticStyle: {
                                    width: "100%",
                                    height: "100%"
                                  },
                                  attrs: {
                                    src: image.image + _vm.lowSrcQuery,
                                    alt: image.name
                                  }
                                }),
                                _c("div", { staticClass: "img-overlay" }, [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "vertical-center-transform",
                                      staticStyle: {
                                        display: "block",
                                        "text-align": "center",
                                        "font-size": "15px",
                                        color: "white",
                                        background: "rgba(0, 0, 0, .6)",
                                        padding: "3%"
                                      }
                                    },
                                    [_vm._v(_vm._s(image.name))]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        display: "block",
                                        "text-align": "center",
                                        "font-size": "18px",
                                        "margin-top": "5px",
                                        "margin-bottom": "5px"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            image.storeName
                                              ? image.storeName + " | "
                                              : ""
                                          ) +
                                          " " +
                                          _vm._s(
                                            image.state ? image.state : "NA"
                                          )
                                      )
                                    ]
                                  )
                                ])
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ])
                }),
                0
              )
            ],
            1
          )
        : _vm._e(),
      !_vm.loading && _vm.hasMoreImages
        ? _c(
            "div",
            { staticClass: "row", staticStyle: { "text-align": "center" } },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn-positive",
                  staticStyle: { "margin-top": "20px" },
                  on: { click: _vm.loadMore }
                },
                [_vm._v("Load More")]
              )
            ]
          )
        : _vm._e(),
      !_vm.loading && _vm.images.length == 0
        ? _c("div", [
            _c(
              "h3",
              { staticStyle: { "text-align": "center", "margin-top": "50px" } },
              [_vm._v("No Pickl Task Images found!")]
            )
          ])
        : _vm._e(),
      _vm.loading
        ? _c("div", [
            _c(
              "h3",
              { staticStyle: { "text-align": "center", "margin-top": "50px" } },
              [_vm._v("Loading Images")]
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }